import React, { useEffect } from 'react'
import { images } from 'Assets/Images'
import { usePrinterContext } from 'state/context/PrinterTemplatesContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { useGetCmfCredit } from '../../../hooks/useGetCmfCredit'
import { FormatMoney } from 'Utils/functions'
import { formatStartEndDate } from 'Utils/Helpers/formatDate'
import { TermsTextArea } from '../../TermsTextArea'

const defTermValue = (startDate, endDate) =>
  `Promoción válida del ${formatStartEndDate(
    startDate,
    endDate
  )}. No aplica con otras promociones ni descuentos, precios no incluyen ITBMS. La tarjeta digital CMF es emitida por CM Financiera, S.A. (CMF). *Valor de cuota referencial, aplican condiciones. La responsabilidad de CMF se limita a los aspectos del crédito. Accede a www.cmf.com.pa para más información.`

export const Square5CCmfOffer = ({ products, i }) => {
  const { terms } = usePrinterContext()
  const { fetchCmfCredit, loading } = useGetCmfCredit({ fetchAllTerms: true })
  const prod = products?.content?.products?.[0]
  const prodBasePrice = FormatMoney(prod?.BasePrice || 0)
  const prodPrice = FormatMoney(prod?.Price || 0)

  const terms1 =
    terms?.find(term => term.prodId === prod?.ProductId)?.value ||
    defTermValue(prod?.StartDate, prod?.FinishDate)

  useEffect(() => {
    if (prod?.Sku && !prod?.cmfCredit) {
      fetchCmfCredit(prod?.Price, prod?.Sku)
    }
  }, [prod?.Sku])

  return (
    <div
      id="printer-preview-left-canvas"
      data-testid="printer-preview-left-canvas"
      className="printer-preview-left-canvas">
      <div className="printer-preview-left-content-body">
        <p className="printer-preview-body-title-cmf">
          {prod?.ProductName || ''}
        </p>
        <p className="printer-preview-body-sku-cmf">{prod?.Sku || ''}</p>
        {prod?.BasePrice && (
          <div className="printer-preview-container-prices">
            <div className="printer-preview-content-price">
              <p
                className="printer-preview-quote-1"
                style={{
                  alignSelf: 'end',
                  marginBottom: 10,
                }}>
                36 cuotas desde
              </p>
              <div
                className="printer-preview-container-price"
                style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 130,
                }}>
                <p className="printer-preview-price-simbol">$</p>
                <p className="printer-preview-price">
                  {FormatMoney(prod?.cmfCredit || 0)?.split('.')?.[0] || ''}
                </p>
                <p className="printer-preview-price-mini">
                  .{FormatMoney(prod?.cmfCredit || 0)?.split('.')?.[1] || '00'}
                </p>
              </div>
            </div>
            <div className="printer-preview-content-price">
              <p className="printer-preview-quote-2">24 cuotas desde</p>
              <div className="printer-preview-container-price">
                <p className="printer-preview-price-simbol-small">$</p>
                <p className="printer-preview-price-small">
                  {FormatMoney(prod?.cmfCredit24 || 0)?.split('.')?.[0] || ''}
                </p>
                <p className="printer-preview-price-small-mini">
                  .
                  {FormatMoney(prod?.cmfCredit24 || 0)?.split('.')?.[1] || '00'}
                </p>
              </div>
            </div>
            <div className="printer-preview-content-price">
              <p className="printer-preview-quote-2">12 cuotas desde</p>
              <div className="printer-preview-container-price">
                <p className="printer-preview-price-simbol-small">$</p>
                <p className="printer-preview-price-small">
                  {FormatMoney(prod?.cmfCredit12 || 0)?.split('.')?.[0] || ''}
                </p>
                <p className="printer-preview-price-small-mini">
                  .
                  {FormatMoney(prod?.cmfCredit12 || 0)?.split('.')?.[1] || '00'}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
      <div
        className="printer-preview-left-content-footer"
        style={{
          marginBottom: -12,
        }}>
        {prod?.BasePrice && (
          <div className="printer-preview-footer-container-prices-offer">
            <div className="printer-preview-footer-container-price">
              <div className="printer-preview-price-before" />
              <p className="printer-preview-footer-price">Antes</p>
              <p className="printer-preview-price-small">
                {!loading && '$' + prodBasePrice}
                {loading && (
                  <FontAwesomeIcon
                    icon={faSpinner}
                    className="spinner"
                    data-testid="spinner"
                    style={{ width: 20 }}
                  />
                )}
              </p>
            </div>

            <div className="printer-preview-footer-container-price">
              <p className="printer-preview-footer-price">Ahora</p>
              <p className="printer-preview-price-small">
                {!loading && '$' + prodPrice}
                {loading && (
                  <FontAwesomeIcon
                    icon={faSpinner}
                    className="spinner"
                    data-testid="spinner"
                    style={{ width: 20 }}
                  />
                )}
              </p>
            </div>
          </div>
        )}

        <div className="printer-preview-content-footer-input-wrapper template-terms-wrapper-to-remove">
          <TermsTextArea
            rows={3}
            prod={prod}
            defaultValue={terms1}
            className="printer-preview-left-content-footer-legal-1"
            styles={{
              fontSize: '9px',
              color: '#000',
              height: '40.5px',
            }}
          />
        </div>
      </div>
      <img
        className="printer-preview-left-image"
        src={images.printer.templates.cochez.cmfOffer4}
        alt="template-preview"
      />
    </div>
  )
}
